import { BlockBlobClient } from '@azure/storage-blob';

export const blobStorageUploadFile = async (uploadSasUrl, file) => {
  if (!uploadSasUrl || !file) {
    return false;
  }

  const blockBlobClient = new BlockBlobClient(uploadSasUrl);
  if (!blockBlobClient) {
    return false;
  }

  const uploadResult = await blockBlobClient.uploadData(file);
  return (
    uploadResult &&
    uploadResult._response &&
    uploadResult._response.status >= 200 &&
    uploadResult._response.status < 300
  );
};
